'use client';

import { useSelectedLayoutSegments } from 'next/navigation';
import { PropsWithChildren, useEffect, useState } from 'react';

import MobileTopBarContext from './MobileTopBarContext';

const MobileTopBarProvider = ({ children }: PropsWithChildren) => {
  const segments = useSelectedLayoutSegments();
  const [title, setTitle] = useState<string>('');
  const [showBottomDivider, setShowBottomDivider] = useState<boolean>(false);

  useEffect(() => {
    if (segments[2] === 'my' && segments[3] === 'collection') {
      if (segments[4] === 'detail') return;

      if (segments[4] === 'list') {
        setTitle('목록');
        return setShowBottomDivider(true);
      }

      setTitle('내 컬렉션');
      return setShowBottomDivider(false);
    }

    if (segments.includes('profiles')) {
      setShowBottomDivider(true);
      return setTitle('프로필 편집');
    }

    if (segments[2] === 'setting') {
      setShowBottomDivider(false);
      return setTitle('알림 설정');
    }
  }, [segments]);

  return (
    <MobileTopBarContext.Provider
      value={{ title, showBottomDivider, setTitle, setShowBottomDivider }}
    >
      {children}
    </MobileTopBarContext.Provider>
  );
};

export default MobileTopBarProvider;
